/** Ordem do catálogo público de serviços (alinhado a serviceDetailDict). */
export const CATALOG_SERVICE_SLUGS = [
  'engenharia-civil',
  'tecnologia',
  'ciberseguranca',
  'gestao-processos',
  'aplicacoes-gestao',
  'seguranca-eletronica',
  'design-marketing',
  'consultoria',
  'turismo',
  'imobiliario',
]
